import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Loader from "./Common/Loader";
import Layout from "./Shared/Layout";
import Banner from "./Shared/Banner";
import OurEminentSolutions from "./Shared/OurEminentSolutions";
import SmartDevelopment from "./Shared/SmartDevelopment";
import Video from "./Shared/Video";
import CollaborateWith from "./Shared/CollaborateWith";
import OurBlogsSection from "./Shared/OurBlogsSection";
import { ThemeContext } from "../Contaxt/ThemeContext";

const Home = () => {
    const { loaderDone, startExit, setIsSettled, hasLoadedOnce, setLasLoadedOnce } =
        useContext(ThemeContext);
    const { pathname } = useLocation();
    const showIntroLoader = pathname === "/";
    const homeReady = !showIntroLoader || loaderDone;

    useEffect(() => {
        if (!showIntroLoader) {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
            document.body.style.backgroundColor = "#fff";
            setIsSettled(true);
            return;
        }

        window.scrollTo(0, 0);
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
        document.body.style.backgroundColor = "#181818";

        return () => {
            document.body.style.overflow = "";
            document.documentElement.style.overflow = "";
        };
    }, [showIntroLoader, setIsSettled]);

    useEffect(() => {
        if (!showIntroLoader || !loaderDone) return;

        const settleTimer = setTimeout(() => {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
            document.body.style.backgroundColor = "#fff";
            setLasLoadedOnce(true);
            setIsSettled(true);
        }, 2200);

        return () => clearTimeout(settleTimer);
    }, [showIntroLoader, loaderDone, setIsSettled, setLasLoadedOnce]);

    return (
        <>
            {showIntroLoader && !loaderDone && <Loader />}

            <div
                className={`home-wrapper ${showIntroLoader && startExit && !hasLoadedOnce ? "reveal" : ""} ${homeReady ? "final" : ""}`}
            >
                <Layout>
                    <Banner />
                    <OurEminentSolutions />
                    <SmartDevelopment />
                    <Video />
                    <CollaborateWith />
                    <OurBlogsSection />
                </Layout>
            </div>
        </>
    );
};

export default Home;
